/**
 * NAME-column subline row — MapPin + facility location tag (#999).
 */

import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  type StyleProp,
  type TextStyle,
} from 'react-native';

import { colors } from '../../theme/colors';
import { spacing } from '../../theme/spacing';
import { locationTagLeadingPrefix } from '../../utils/locationTagListDisplay';
import { MapPin } from '../icons';

export interface LocationTagListSublineProps {
  locationTagName: string;
  /** Full NAME subline when compact parts precede the tag (e.g. "Qty 2 · "). */
  subline?: string;
  leadingText?: string;
  style?: StyleProp<TextStyle>;
  compact?: boolean;
  testID?: string;
}

export const LocationTagListSubline: React.FC<LocationTagListSublineProps> = ({
  locationTagName,
  subline,
  leadingText,
  style,
  compact = false,
  testID,
}) => {
  const prefix =
    leadingText ??
    locationTagLeadingPrefix(subline, locationTagName) ??
    undefined;

  return (
    <View style={styles.row} testID={testID}>
      {prefix ? (
        <Text
          style={[styles.text, compact && styles.compactText, style]}
          numberOfLines={1}
        >
          {prefix}
        </Text>
      ) : null}
      <MapPin
        size={compact ? 11 : 12}
        color={colors.textMuted}
        style={styles.icon}
      />
      <Text
        style={[
          styles.text,
          compact && styles.compactText,
          styles.tagText,
          style,
        ]}
        numberOfLines={1}
      >
        {locationTagName}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 0,
    gap: spacing.xs,
  },
  icon: {
    flexShrink: 0,
  },
  text: {
    flexShrink: 1,
  },
  compactText: {
    fontSize: 11,
  },
  tagText: {
    flex: 1,
  },
});
